import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
  useContext,
} from 'react'
import getQuery from '@arsenal/arsenal/modules/getQuery'
import { useRouter } from 'next/router'
import Dialog from 'Components/dialog'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { ObjectInterface } from '@arsenal/arsenal/modules/interface/objectInterface'
import {
  sendTeaCommEvent,
  sendTeaEnterEvent,
  setEnterPageBizParams,
  setStayPageBizParams,
} from 'lib/tea-analyze'
import Pagination from 'Components/new/pagination'
import CommunityHeader from './components/community-header'
import classNames from 'classnames'
import Button from 'Components/button'
import ToolTip from 'Components/new/tool-tip'
import PublishDropdown, {
  PublishOperation,
  usePublish,
} from 'Components/new/community-card/publish-dropdown'
import Sort from './components/sort'
import MoreTableList from './components/more-table-list'
import Content, { TopLabel } from 'New/community/components/content'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'
import StickyHeader from 'Components/new/scroll-sticky/sticky-header'
import Toast from 'Components/toast-messager'
import Publisher from 'Components/publisher/publisher'
import Breadcrumb from 'Components/breadcrumb'
import Copyright from 'Components/new/copyright'
import MyCommunity from 'Components/new/hot/my-community'
import DongcheScore from './components/dongche-score'
import Empty from './components/empty'
import HotTalkCommunity from 'New/community/components/hot-talk-community'
import getCheyouHead from './services/getCheyouHead'
import getCheyouSeriesReviewCard from './services/getCheyouSeriesReviewCard'
import getCheYouList from './services/getCheYouList'
import getCheYouHotCard from './services/getCheYouHotCard'
import Head from 'Components/head'
import tdk from './tdk'
import tabMapping, { getKeyByValue } from './tabMapping'
import getAnnouncements from 'New/community/services/getAnnouncements'
import anyLink from 'Components/new/links/any-link'
import { size14Class } from 'Components/new/community-card/text'
import Link from 'next/link'
import OverflowTooltip from 'Components/new/overflow-tooltip'
import { headerHeight } from 'Components/new-header'
import { makeCommunityUrl } from 'Components/new/links/community-link'
import getTopicHot from 'New/community-topic/services/getTopicHot'
import HotTopic from 'Components/new/hot/hot-topic'
import dialogStyle from 'Components/dialog.module.scss'
import Confirm from 'Components/new/confirm'
import { getInnerLinkList } from 'Components/new/inner-link'
import { getOuterLinkList } from 'Components/new/outer-link'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import { SpiderContext } from '../../pages/_app'

const cheyouHeadCache = new Map<string, any>()
const cheyouSeriesReviewCardCache = new Map<string, any>()
const cheYouHotCardCache = new Map<string, any>()
const topicHotCache = new Map<string, any>()

interface ICommunityProps {
  tab: string
  sort: string
  series_id: string
  page: number
  total: number
  cheyouHead: any
  cheyouSeriesReviewCard: any
  cheyouList: any
  cheyouHotCard: any
  announcements: any
  topicHot: any
  cheyouHeadCacheKey: string
  cheyouSeriesReviewCardCacheKey: string
  cheYouHotCardCacheKey: string
  topicHotCacheKey: string
}
interface ITab {
  chi_name: string
  tab_name: string
}
const sort_list = [
  {
    chi_name: '最新回复',
    eng_name: 'reply',
  },
  {
    chi_name: '最新发布',
    eng_name: 'release',
  },
  // {
  //   chi_name: '最新推荐',
  //   eng_name: 'recommend',
  // },
]

export const allDefaultTab = 'dongtai'
export const allDefaultSort = 'reply'

const Community = ({
  tab,
  sort,
  series_id,
  page = 1,
  cheyouHead,
  cheyouSeriesReviewCard,
  cheyouList,
  cheyouHotCard,
  announcements,
  topicHot,
  cheyouHeadCacheKey,
  cheyouSeriesReviewCardCacheKey,
  cheYouHotCardCacheKey,
  topicHotCacheKey,
}: ICommunityProps) => {
  if (typeof window !== 'undefined') {
    cheyouHeadCache.set(cheyouHeadCacheKey, cheyouHead)
    cheyouSeriesReviewCardCache.set(
      cheyouSeriesReviewCardCacheKey,
      cheyouSeriesReviewCard
    )
    cheYouHotCardCache.set(cheYouHotCardCacheKey, cheyouHotCard)
    topicHotCache.set(topicHotCacheKey, topicHot)
  }
  const tab_list = cheyouHead?.tab_info?.map((item: ITab) => {
    return {
      chi_name: item?.chi_name,
      tab_name: tabMapping.get(item?.chi_name),
    }
  })

  const koubeiItem = {
    chi_name: '懂车分（口碑）',
    tab_name: 'koubei',
    as: `/auto/series/score/${cheyouHead?.series_id}-x-x-x-x-x-x`,
    href: `/auto/score?seriesId=${cheyouHead?.series_id}-x-x-x-x-x-x`,
  }
  const wendaItem = { chi_name: '问答', tab_name: 'wenda' }

  if (cheyouHead?.have_koubei && tab_list) {
    tab_list.splice(4, 0, koubeiItem)
  }
  const more_tab_list = cheyouHead?.wenda_tab_info?.map((item: ITab) => {
    return {
      chi_name: item?.chi_name,
      tab_name: tabMapping.get(item?.chi_name),
    }
  })

  if (more_tab_list && tab_list) {
    tab_list.splice(5, 0, wendaItem)
    // tab_list.push({ chi_name: '问答', tab_name: 'wenda' })
  }

  const qa_arr = more_tab_list?.map((item: ITab) => {
    return item.tab_name
  })

  const router = useRouter()
  const [isJoining, setJoining] = useState(false)
  const [joinedDays, setJoinedDays] = useState(cheyouHead?.joined_days)
  // const [isFixed, setIsFixed] = useState(false)
  // const responsive = useResponsive()

  // const [currentSort, setCurrentSort] = useState(initSort || '最新回复')
  const currentSort = useMemo(() => {
    switch (sort) {
      case 'recommend':
        return '最新推荐'
      case 'release':
        return '最新发布'
      default:
        return '最新回复'
    }
  }, [sort])

  useEffect(() => {
    const stayParms = {
      page_id: 'page_ugc_forum_home',
      car_series_id: String(cheyouHead?.series_id || cheyouHead?.motor_id),
      car_series_name: cheyouHead?.name,
      sub_tab: getKeyByValue(tab),
    }
    setStayPageBizParams(stayParms)
    const parms = {
      page_id: 'page_ugc_forum_home',
      car_series_id: String(cheyouHead?.series_id || cheyouHead?.motor_id),
      car_series_name: cheyouHead?.name,
      sub_tab: getKeyByValue(tab),
    }
    setEnterPageBizParams(parms)
    sendTeaEnterEvent(parms)
  }, [router.asPath])

  const handleTabClick = (e: any) => {
    const { name } = e.target.dataset
    sendTeaCommEvent('clk_event', {
      page_id: 'page_ugc_forum_home',
      event_id: 'forum_home_second_tab_clk',
      // car_series_id: String(cheyouHead?.series_id || cheyouHead?.motor_id),
      // car_series_name: cheyouHead?.name,
      sub_tab: getKeyByValue(name),
      module_id: 'forum_home_second_tab_module',
    })
  }
  const handleMoreTabClick = (e: any) => {
    const { name } = e.target.dataset
    // setCurrentMoretTab(name)
    sendTeaCommEvent('clk_event', {
      page_id: 'page_ugc_forum_home',
      event_id: 'qa_second_tab_clk',
      car_series_id: String(cheyouHead?.series_id || cheyouHead?.motor_id),
      car_series_name: cheyouHead?.name,
      sub_tab: '问答',
      obj_text: getKeyByValue(name),
    })
  }

  // const handleSortClick = (e: any) => {
  //   const { name } = e.target.dataset
  //   // setCurrentSort(name)
  // }

  const [confirmVisible, setConfirmVisible] = useState(false)
  const isConfirmRef = useRef(false)

  const handleJoinClick = useLoginCheckCallback(
    useCallback(() => {
      sendTeaCommEvent('clk_event', {
        page_id: 'page_ugc_forum_home',
        event_id: 'join_forum_home_button',
        car_series_id: String(cheyouHead?.series_id || cheyouHead?.motor_id),
        car_series_name: cheyouHead?.name,
        motor_id: String(cheyouHead?.motor_id),
        sub_tab: getKeyByValue(tab),
      })

      if (joinedDays && !isConfirmRef.current) {
        setConfirmVisible(true)
        return
      }

      setJoining(true)
      const params = {
        car_id: series_id,
        car_id_type: cheyouHead?.car_id_type,
      }

      const url = joinedDays
        ? '/motor/garage/relation/unfollow_car/web'
        : '/motor/garage/relation/follow_car/web'

      fetch(url, {
        method: 'POST',
        headers: {
          'tt-anti-token': window.localStorage.getItem('tt-anti-token') || '',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: serializeObject(params),
        credentials: 'include',
      })
        .then((res) => {
          if (res?.status === 200) {
            if (joinedDays) {
              setJoinedDays('')
              Toast.show({
                text: `你已退出${cheyouHead?.series_name}车友圈`,
              })
              isConfirmRef.current = false
            } else {
              setJoinedDays('1')
              Toast.show({
                text: '您已加入圈子，可在我的关注-关注车友圈查看已加入车友圈',
              })
            }
          }

          setJoining(false)
        })
        .catch(() => {
          setJoining(false)
        })
    }, [joinedDays, cheyouHead, series_id, tab]),
    useMemo(
      () => ({
        enter_method: 'other',
      }),
      []
    )
  )

  const handleConfirm = useCallback(() => {
    isConfirmRef.current = true
    handleJoinClick()
    setConfirmVisible(false)
  }, [handleJoinClick])

  const {
    isShowPublish,
    setIsShowPublish,
    operation,
    handlePublish,
    publishSuccess,
  } = usePublish()

  const handlePublishRef = useRef(handlePublish)
  handlePublishRef.current = handlePublish

  useEffect(() => {
    setTimeout(() => {
      if (localStorage.getItem('showQA') === 'yes') {
        localStorage.removeItem('showQA')
        handlePublishRef.current({
          title: '提问',
          type: 'qa',
        })
      }
    }, 200)
  }, [])

  const handlePublishClick = (title: string) => {
    sendTeaCommEvent('clk_event', {
      page_id: 'page_ugc_forum_home',
      event_id: 'send_module_button_clk',
      car_series_id: String(cheyouHead?.series_id || cheyouHead?.motor_id),
      car_series_name: cheyouHead?.name,
      motor_id: cheyouHead?.motor_id,
      sub_tab: getKeyByValue(tab),
      module_id: 'send_module_button',
      obj_text: title,
    })
  }

  const curTDK = useMemo(
    () =>
      tdk({
        series_name: cheyouHead?.name,
        page,
        total_count: cheyouList?.total_count,
        currentTab: tab,
      }),
    [cheyouHead?.name, cheyouList?.total_count, page, tab]
  )

  const announcementList =
    tab === allDefaultTab ? announcements?.announcement_list || [] : []

  const { isSpider } = useContext(SpiderContext)
  return (
    <>
      <Head {...curTDK}>
        <link
          rel="alternate"
          media="only screen and(max-width: 640px)"
          href={`https://m.dongchedi.com${router.asPath}`}
        />
      </Head>

      <Breadcrumb
        style={{ padding: '0 4%' }}
        hideLine={true}
        path={[
          { name: '首页', href: '/home', as: '/' },
          {
            name: '车友圈',
            href: '/car_fans_community',
            as: '/car_fans_community',
            // cheyouHead?.brand_name ||
            // src: cheyouHead?.brand_logo,
            // href: !cheyouHead?.brand_name
            //   ? '/car_fans_community'
            //   : `/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${cheyouHead?.brand_id}&text=${cheyouHead?.brand_name}`,
            // as: !cheyouHead?.brand_name
            //   ? '/car_fans_community'
            //   : `/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${cheyouHead?.brand_id}&text=${cheyouHead?.brand_name}`,
          },
          {
            name: cheyouHead?.series_name || cheyouHead?.name,
            href:
              cheyouHead?.car_id_type === 2
                ? `/auto/series?seriesId=${cheyouHead?.series_id}`
                : '',
            as:
              cheyouHead?.car_id_type === 2
                ? `/auto/series/${cheyouHead?.series_id}`
                : '',
          },
        ]}
      />
      {/* <div className="tw-h-auto"> */}
      <CommunityHeader
        cheyouHead={cheyouHead}
        cheyouSeriesReviewCard={cheyouSeriesReviewCard}
        series_id={cheyouHead?.series_id || cheyouHead?.motor_id}
        currentTab={tab}
        isJoining={isJoining}
        joined_days={joinedDays}
        handleJoinClick={handleJoinClick}
      />
      <div
        className="tw-grid tw-grid-cols-40 tw-gap-12 tw-mt-40"
        style={{ padding: '0 4%' }}
      >
        {!isSpider && (
          <PublishOperation
            className="tw-col-span-40 md:tw-col-span-10 tw-order-1 md:tw-order-2"
            onClick={handlePublishClick}
          />
        )}
        <div className="tw-col-span-40 md:tw-col-span-30 tw-row-span-3 tw-order-2 md:tw-order-1 2xl:tw-px-60">
          <StickyHeader className="tw-h-40">
            {(isFixed) => {
              return (
                <div
                  className={classNames('tw-flex tw-w-full', {
                    community: isFixed,
                    'tw-h-full': isFixed,
                  })}
                >
                  <div className="tw-flex tw-items-center tw-relative tw-flex-1">
                    {isFixed && series_id && (
                      <h2
                        className={classNames(
                          ' tw-pl-28 tw-h-34 tw-leading-34 tw-text-24 tw-font-medium tw-whitespace-nowrap '
                        )}
                      >
                        {cheyouHead?.series_name || cheyouHead?.name}车友圈
                        {/* <i className="DCD_Icon icon_triangle_right tw-text-24" /> */}
                      </h2>
                    )}

                    <div
                      className={classNames(
                        'tw-flex tw-w-full tw-justify-between tw-px-16 tw-items-center',
                        {
                          'tw-ml-40': isFixed,
                        }
                      )}
                    >
                      <OverflowTooltip
                        itemCount={tab_list?.length}
                        activeIndex={tab_list?.findIndex(
                          (d: any) => d?.tab_name === tab
                        )}
                        renderMoreWrapper={() => (content) =>
                          (
                            <div
                              className={classNames(
                                'tw-flex tw-flex-col tw-text-14 md:tw-text-16'
                              )}
                            >
                              {content}
                            </div>
                          )}
                        className={classNames(
                          isFixed ? headerHeight : 'tw-h-40'
                        )}
                        renderMoreButton={() => {
                          return (
                            <p
                              className={classNames(
                                'tw-whitespace-nowrap tw-cursor-pointer'
                              )}
                            >
                              更多
                              <i
                                className={`DCD_Icon icon_PC-triangle-down`}
                                style={{ display: 'inline-block' }}
                              />
                            </p>
                          )
                        }}
                      >
                        {({ index, isInMore, close, isCover }) => {
                          const item = tab_list[index]
                          const { chi_name, tab_name, href, as } = item
                          const targetTab = qa_arr?.includes(tab)
                            ? 'wenda'
                            : tab

                          const isActive =
                            targetTab === item?.tab_name && !isInMore
                          return (
                            <div
                              className={classNames(
                                'tw-text-14 md:tw-text-16 tw-h-full ',
                                {
                                  'md:tw-ml-40 tw-ml-24': !isInMore && index,
                                  'in-more-tab tw-flex tw-items-center tw-justify-center tw-px-16  tw-h-40':
                                    isInMore,
                                  'tw-opacity-0': isCover && !isInMore,
                                }
                              )}
                            >
                              <Link
                                href={href || `/new_community`}
                                as={
                                  as ||
                                  makeCommunityUrl({
                                    id: series_id,
                                    tab: tab_name,
                                    sort: allDefaultSort,
                                  })
                                }
                                key={tab_name}
                              >
                                <a
                                  onClick={(e) => {
                                    if (close) {
                                      close()
                                    }

                                    handleTabClick(e)
                                  }}
                                >
                                  <h2
                                    className={classNames(
                                      'tw-relative tw-inline-flex tw-items-center ',
                                      isInMore
                                        ? 'tw-h-40'
                                        : isFixed
                                        ? headerHeight
                                        : 'tw-h-40',

                                      {
                                        'active tw-font-medium': isActive,
                                      }
                                    )}
                                    data-name={tab_name}
                                    style={{
                                      color: 'black',
                                    }}
                                  >
                                    {chi_name}
                                  </h2>
                                </a>
                              </Link>
                            </div>
                          )
                        }}
                      </OverflowTooltip>
                    </div>
                  </div>

                  {isFixed && (
                    <div className="tw-flex tw-items-center">
                      <Button
                        loading={isJoining}
                        onClick={handleJoinClick}
                        style={{
                          height: '36px',
                          paddingLeft: '8px',
                          paddingRight: '8px',
                          lineHeight: '36px',
                          marginRight: '16px',
                          border: '0.5px solid #c9cbd6',
                          backgroundColor: joinedDays ? '#E6E6E6 ' : '#fff',
                        }}
                      >
                        {joinedDays
                          ? `已加入${formatNumber(joinedDays)}天`
                          : '加入圈子'}
                      </Button>
                      <ToolTip
                        theme={'light'}
                        placement="bottom-end"
                        arrowVisible={false}
                        content={
                          <PublishDropdown
                            onClick={(text) => {
                              handlePublishClick(text)
                            }}
                          />
                        }
                      >
                        <button
                          type="button"
                          className="tw-w-80 tw-h-36 tw-rounded-4 tw-bg-common-black hover:tw-bg-opacity-80 tw-text-white"
                          onClick={() => {
                            handlePublish()
                            handlePublishClick('发图文')
                          }}
                        >
                          发动态
                          <i
                            className={`DCD_Icon icon_triangle_down_12`}
                            style={{ display: 'inline-block' }}
                          />
                        </button>
                      </ToolTip>
                    </div>
                  )}
                </div>
              )
            }}
          </StickyHeader>
          <div style={{ height: '0.5px' }} className=" tw-bg-color-gray-600" />
          <div className="data-wrapper tw-pt-12">
            {cheyouList?.cheyou_list && (
              <div>
                {(qa_arr?.includes(tab) || tab === 'wenda') &&
                  cheyouList?.cheyou_list && (
                    <div className="tw-w-full tw-h-auto tw-bg-white tw-px-16 tw-mt-12 tw-py-12">
                      <MoreTableList
                        more_tab_list={more_tab_list}
                        currentMoreTab={tab}
                        series_id={series_id}
                        handleMoreTabClick={handleMoreTabClick}
                      />
                    </div>
                  )}
              </div>
            )}

            {announcementList.length ? (
              <div className="tw-bg-white tw-px-16 tw-py-12 ">
                {announcementList.map((item: any, index: number) => {
                  return (
                    <React.Fragment key={index}>
                      {anyLink({
                        id: item.gid_str,
                        articleType: item.article_type,
                      })(
                        <div
                          className={classNames('tw-flex tw-item-center', {
                            'tw-mt-6': index,
                          })}
                          onClick={() => {
                            sendTeaCommEvent('clk_event', {
                              page_id: 'page_ugc_forum_home',
                              event_id: 'top_content_card_clk',
                              car_series_id: String(
                                cheyouHead?.series_id || cheyouHead?.motor_id
                              ),
                              car_series_name: cheyouHead?.name,
                              sub_tab: getKeyByValue(tab),
                              module_id: 'community_notice_module',
                              group_id: item?.gid_str,
                              author_id: item?.user_id,
                            })
                          }}
                        >
                          <TopLabel className="tw-bg-common-blue tw-bg-opacity-10 tw-flex-none">
                            {item.header}
                          </TopLabel>

                          <p
                            className={classNames(
                              'tw-ml-12 tw-flex-auto line-1 tw-leading-24',
                              size14Class
                            )}
                          >
                            {item.content}
                          </p>
                          <i className="tw-flex-none DCD_Icon icon_PC-triangle tw-ml-24" />
                        </div>
                      )}
                    </React.Fragment>
                  )
                })}
              </div>
            ) : null}
            {cheyouList?.cheyou_list && (
              <div className="tw-flex tw-w-full tw-h-auto tw-items-center tw-justify-between tw-mt-12 tw-px-16">
                {tab_list && !!tab_list?.length && (
                  <Sort
                    current_sort={currentSort}
                    sort_list={sort_list}
                    tab_name={tab}
                    series_name={cheyouHead?.series_name || cheyouHead?.name}
                    series_id={series_id}
                  />
                )}
                <p className="tw-text-color-gray-700">
                  共{cheyouList?.total_count}条内容
                </p>
              </div>
            )}
            {cheyouList?.cheyou_list ? (
              <Content
                data={cheyouList}
                announcements={tab === allDefaultTab ? announcements : null}
                teaParams={{
                  car_series_id: String(
                    cheyouHead?.series_id || cheyouHead?.motor_id
                  ),
                  car_series_name: cheyouHead?.name,
                  sub_tab: getKeyByValue(tab),
                }}
                sort={sort}
              />
            ) : (
              <Empty />
            )}
          </div>
          <Pagination
            className="tw-justify-center tw-my-24"
            theme={'white'}
            total={cheyouList?.total_count}
            pageSize={30}
            currentPage={page}
            renderLink={(curPage) => (content) => {
              return (
                <Link
                  href="/new_community"
                  as={makeCommunityUrl({
                    id: series_id,
                    tab,
                    sort,
                    page: curPage,
                  })}
                >
                  <a>{content}</a>
                </Link>
              )
            }}
            onJump={(curPage) => {
              const query = serializeObject(getQuery() as ObjectInterface)
              router.push(
                '/new_community',
                `/community/${series_id}/${tab}${
                  sort !== 'reply' ? `-${sort}` : ''
                }${curPage > 1 ? `-${curPage}` : ''}${query ? `?${query}` : ''}`
              )
            }}
            onClick={(curPage) => {
              sendTeaCommEvent('clk_event', {
                page_id: 'page_ugc_forum_home',
                event_id: 'bottom_turn_page_button_clk',
                car_series_id: String(
                  cheyouHead?.series_id || cheyouHead?.motor_id
                ),
                car_series_name: cheyouHead?.name,
                // motor_id: cheyouHead?.motor_id,
                sub_tab: getKeyByValue(tab),
                module_id: 'buttom_turn_page_module',
                obj_text: String(curPage),
              })
            }}
          />
        </div>
        <div className="tw-col-span-40 md:tw-col-span-10 tw-order-3">
          {!isSpider && (
            <>
              {!!cheyouSeriesReviewCard?.review_people_count && (
                <a
                  target="_blank"
                  href={`/auto/series/score/${cheyouHead?.series_id}-x-x-x-x-x`}
                >
                  <DongcheScore
                    cheyouSeriesReviewCard={cheyouSeriesReviewCard}
                  />
                </a>
              )}
              <HotTopic
                topicHot={topicHot}
                title={`${cheyouHead?.name || ''}热门话题`}
                onClickItem={({ id, name }) => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'hot_topic_talk_content_clk',
                    module_id: 'hot_top_talk_module',
                    sub_tab: getKeyByValue(tab),
                    topic_id: id,
                    obj_text: name,
                  })
                }}
              />
              {cheyouHotCard && (
                <HotTalkCommunity
                  cheyouHotCard={cheyouHotCard}
                  series_id={cheyouHead?.series_id || cheyouHead?.motor_id}
                  series_name={cheyouHead?.name}
                />
              )}
              <MyCommunity
                onClickTitle={() => {
                  sendTeaCommEvent('clk_event', {
                    page_id: 'page_ugc_forum_home',
                    event_id: 'my_forum_home_more_button',
                    module_id: 'my_car_circle_module',
                    motor_id: String(cheyouHead?.motor_id),
                  })
                }}
                onClickItem={({ id }) => {
                  sendTeaCommEvent('clk_event', {
                    page_id: 'page_ugc_forum_home',
                    event_id: 'my_forum_home_module_clk',
                    module_id: 'my_car_circle_module',
                    car_series_id:
                      cheyouHead?.series_id || cheyouHead?.motor_id,
                    car_series_name: cheyouHead?.name,
                    motor_id: id,
                  })
                }}
              />
            </>
          )}
          <Copyright className="tw-mt-12" responsive />
        </div>
      </div>
      <Dialog
        className={dialogStyle['space-medium']}
        headerClass={dialogStyle['space-medium']}
        visible={isShowPublish}
        onClose={() => setIsShowPublish(false)}
      >
        {isShowPublish ? (
          <Publisher
            defaultCommunity={
              series_id
                ? {
                    series_id,
                    series_name: cheyouHead?.series_name || '',
                  }
                : undefined
            }
            onPublish={publishSuccess}
            defaultTab={operation}
          />
        ) : null}
      </Dialog>
      <Dialog
        title={'您要退出车友圈吗？'}
        visible={confirmVisible}
        className={dialogStyle['space-medium']}
        headerClass={dialogStyle['space-medium']}
        onClose={() => setConfirmVisible(false)}
      >
        <Confirm
          cancelText={'退出'}
          confirmText={'暂不退出'}
          onConfirm={() => setConfirmVisible(false)}
          onCancel={handleConfirm}
        >
          退出后加圈天数将清零
        </Confirm>
      </Dialog>

      <style jsx>
        {`
          .community {
            background: url(${require('static/cheyouquan-yellow.svg')}) left
              center/24px 24px no-repeat;
          }

          .in-more-tab:hover {
            background-color: #fff9e6;
          }

          .active:after {
            content: '';
            width: 100%;
            height: 4px;
            background: #ffcc32;
            position: absolute;
            left: 0;
            bottom: 0;
            margin: auto;
          }
        `}
      </style>
    </>
  )
}
Community.getInitialProps = async ({ req, asPath }: any) => {
  const [, seriesId, tab = allDefaultTab, sort = allDefaultSort, page = 1] =
    asPath.match(
      /community\/(\d+)(?:\/([^-0-9]+)?(?:-([^-0-9]+))?(?:-?([1-9][0-9]*))?)?/
    ) || []

  const curPage = Math.max(Number(page), 1)

  const cheyouHeadCacheKey = serializeObject({
    series_or_motor_id_head: seriesId,
  })
  const cheyouSeriesReviewCardCacheKey = serializeObject({
    series_or_motor_id_series: seriesId,
  })
  const cheYouHotCardCacheKey = serializeObject({
    series_or_motor_id_hot: seriesId,
  })
  const topicHotCacheKey = serializeObject({
    series_or_motor_id: seriesId,
  })

  const cheyouHead = cheyouHeadCache.get(cheyouHeadCacheKey)
  const cheyouSeriesReviewCard = cheyouSeriesReviewCardCache.get(
    cheyouSeriesReviewCardCacheKey
  )
  const cheYouHotCard = cheYouHotCardCache.get(cheYouHotCardCacheKey)
  const topicHot = topicHotCache.get(topicHotCacheKey)

  const data = (
    await Promise.allSettled([
      cheyouHead
        ? Promise.resolve(cheyouHead)
        : getCheyouHead({ series_or_motor_id: seriesId }, req),
      cheyouSeriesReviewCard
        ? Promise.resolve(cheyouSeriesReviewCard)
        : getCheyouSeriesReviewCard({ series_or_motor_id: seriesId }, req),
      getCheYouList(
        {
          series_or_motor_id: seriesId,
          sort_type: sort === 'reply' ? 2 : 1,
          tab_name: tab === 'reply' ? 'dongtai' : tab,
          offset: (curPage - 1) * (req?.isSpider ? 3 : 30),
          count: req?.isSpider ? 3 : 30,
        },
        req
      ),
      cheYouHotCard
        ? Promise.resolve(cheYouHotCard)
        : getCheYouHotCard({ series_or_motor_id: seriesId }, req),
      getAnnouncements({ series_or_motor_id: seriesId }, req),
      topicHot
        ? Promise.resolve(topicHot)
        : getTopicHot(
            {
              series_or_motor_id: seriesId,
            },
            req
          ),
      getInnerLinkList(asPath, req),
      getOuterLinkList(asPath, req),
    ])
  ).map((d) => (d.status === 'fulfilled' ? d.value : null))
  return {
    _pageType: 'full auto-nav',
    tab: tab === 'reply' ? 'dongtai' : tab,
    sort,
    series_id: seriesId,
    page: curPage,
    cheyouHead: data[0],
    cheyouSeriesReviewCard: data[1],
    cheyouList: data[2],
    cheyouHotCard: data[3],
    announcements: data[4],
    topicHot: data[5],
    innerList: data?.[6],
    outerList: data?.[7],
    cheyouHeadCacheKey,
    cheyouSeriesReviewCardCacheKey,
    cheYouHotCardCacheKey,
    topicHotCacheKey,
  }
}

export default Community
